import { render, staticRenderFns } from "./AllClients.vue?vue&type=template&id=b3452560&"
import script from "./AllClients.vue?vue&type=script&lang=js&"
export * from "./AllClients.vue?vue&type=script&lang=js&"
import style0 from "./AllClients.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports